module.exports = __webpack_public_path__ + "img/arrow_drop_down_5.bf9a63b6.svg";